 <template>
     <div id="app">
        <notifications group="foo" position="top right" width="225px"/>
        <router-view/> 
    </div>
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import '../static/common/js/bootstrap.min.js'
    import '../static/common/js/slick.js'
	import '../static/prism/js/jquery.overlayScrollbars.min.js'
    import feather from '../static/prism/js/feather.min.js'
    import select from '../static/prism/js/awselect.js' 
	export default {
		name: 'app',
		methods:{
			...mapActions({
               
            })
		},
        created() {
		    
        },	
        updated() {
            feather.replace();
        }
    }
</script>
<style>
    @Import '../static/common/css/bootstrap.min.css';
    @Import '../static/common/css/bootstrap-vue.min.css';
    @Import '../static/common/css/font-awesome.min.css';
	@Import '../static/prism/css/OverlayScrollbars.min.css';
	@Import '../static/prism/css/awselect.css';
    @Import '../static/prism/css/stx-chart.css';
	@Import '../static/prism/css/style.css';

    @Import '../static/prism/css/stylesheet.css';
	@Import '../static/prism/css/responsive.css';
</style>


// WEBPACK FOOTER //
// src/App.vue